module.exports = __webpack_public_path__ + "static/img/vr3.3366f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr3.png
// module id = 5GAz
// module chunks = 1